import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation,HostListener, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SubpoolService } from '../../../../../services/subpool.service';
import { IVessel } from '../../../../../models/vessels.model';
import { PoolingPortalService } from '../../../../../services/pooling-portal.service';
import { Subscription } from 'rxjs'; 
import { SubPoolModel, Setting } from '../../../../../interface/fleetList.interface';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-sub-pool',
  templateUrl: './sub-pool.component.html',
  styleUrls: ['./sub-pool.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubPoolComponent {
  @Input() subPools: any[] = [];
  @Input() vessels: any[] = [];
  @Output() onPageTabClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() addNewPool: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() refreshSubpool: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  public subPoolManageForm: UntypedFormGroup;
  public addSubpoolFormGroup: UntypedFormGroup;
  public editSubpoolFormGroup: UntypedFormGroup[] = [];
  subscription: Subscription;

  viewModel: SubPoolModel  = {
     tab: 'all',
     deleteSubPoolName: '',
     activeSubPoolsCount: 0,
     inactiveSubPoolsCount:  0,
     iDeleteSubpoolMoveForm:  false,
     iDeleteSubpoolForm: false,
     submit:false,
     iManageSubpool:  false,
     iManageSubpoolAdd: false,
     manageSubpoolSubmit: false,
     showAddNewSubpoolBlock: false,
     moveSubpoolName: "",
     editSubPoolValue: "",
     currentYear: new Date(),
      fleet: '',
      tempX : 0,
      tempY : 0,
      addNewSubpoolX : 0,
      aadNewSubpoolY : 0,
      showEditSubpoolY : 0,
      showEditSubpoolX : 0,
      subpoolDurationValue: '',
      selectedAttributes : { label: 'This year', value: '2023'},
      monthNameArray : this._poolingPortalService.getMonthShortNames(),
      showEditSubpoolBlock: [],
      showSubpoolAction: [],
      filteredVesselBySubpool: [],
      suggestedSubpools:[],
      subpoolsMonthlyList:[],
      subPoolsDurations:[],
      subPoolDetail:{ name: "", subpoolCode: ""}
     
  }
  setting:Setting  = {showCloseIcon: false,backdropClick: false}
  
  constructor(
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    private _subpoolService: SubpoolService,
    private _poolingPortalService: PoolingPortalService,
    private toasterService: ToasterService,
    private _el: ElementRef
  ) {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let change in changes) {
      if (change == "subPools") {
        this.subPools = changes[change].currentValue;
        this.createEditSubpoolForm();
      }
      if (change == "vessels") {
        this.vessels = changes[change].currentValue;
      }
    }
    
  }

  ngOnInit() {
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.viewModel.fleet = fleet
        if(this.viewModel.fleet == 'SNAPS'){
          this.viewModel.tab = this.subPools[0].name;
        }
      }
    )
    this.createAddSubpoolForm();
  }

 

  clickOnPageTab(subPool: any) {
    this.viewModel.tab = subPool;
    this.onPageTabClick.emit(subPool);
    this.addNewPool.emit(false);
  }

  showEditSubpool(subpool: string, index: number) {
    this.viewModel.showEditSubpoolBlock[index] = true;
    this.viewModel.editSubPoolValue = subpool;
    this.editSubpoolFormGroup[index].setValue({ "name": subpool })
  }

  onPageNewTabClick() {
    this.viewModel.showAddNewSubpoolBlock = !this.viewModel.showAddNewSubpoolBlock;
    this.viewModel.submit = false;
  }

  createAddSubpoolForm() {
    this.addSubpoolFormGroup = this.fb.group({
      name: ['',[Validators.required,Validators.pattern("^[a-zA-Z0-9 ]*$")]],
      fleet: ['',[Validators.required]],
    });
  }

  createSubPoolManageForm() {
    let monthYear = this.getMonthYear();
    
    this.subPoolManageForm = this.fb.group({
      month: [monthYear.month + 1, Validators.required],
      year: [monthYear.year, Validators.required],
      subpoolName: [this.viewModel.editSubPoolValue, Validators.required],
      accountingVoyage: ['', [Validators.required,Validators.pattern("^-?[0-9]{0,10}(([\\.]{1}[0-9]{0,3})|())$")]],
      scrubberSavings: ['', [Validators.required,Validators.pattern("^-?[0-9]{0,10}(([\\.]{1}[0-9]{0,3})|())$")]],
    });
  }


  createEditSubpoolForm() {
    this.editSubpoolFormGroup = [];
    this.subPools.forEach((value: any, index: number) => {
      this.editSubpoolFormGroup[index] = this.fb.group({
        name: ['',[Validators.required,Validators.pattern("^[a-zA-Z0-9 ]*$")]],
      });
    })
  }
  
  showDeleteSubpool(subpool: string, index: number) {
    this.viewModel.suggestedSubpools = [];
    this.viewModel.filteredVesselBySubpool = this.vessels.filter((vessel: IVessel) => vessel.subPool == subpool);
    this.viewModel.deleteSubPoolName = subpool;
    if (this.viewModel.filteredVesselBySubpool.length > 0) {
      this.viewModel.activeSubPoolsCount = this.viewModel.filteredVesselBySubpool.filter((vessel) => vessel.iActive).length;
      this.viewModel.inactiveSubPoolsCount = this.viewModel.filteredVesselBySubpool.filter((vessel) => !vessel.iActive).length;
      this.viewModel.iDeleteSubpoolMoveForm = true;
      this.subPools.forEach((value: any) => {
        if(value.name != subpool){
          this.viewModel.suggestedSubpools.push(value.name);
        }
      })
    } else {
      this.viewModel.iDeleteSubpoolForm = true;
    }

  }

  updateSubpool(oldName: string, index: number) {
    this.viewModel.submit = true;
    this._subpoolService.updateSubpool(oldName, this.editSubpoolFormGroup[index].value.name)
      .subscribe({
        next: (res: any) => {
          const response = res.data.updateSubpool;
          if (response.success) {
            this.viewModel.showEditSubpoolBlock[index] = false;
            if(this.viewModel.tab == oldName){
              this.viewModel.tab = this.editSubpoolFormGroup[index].value.name;
            }
            this.editSubpoolFormGroup[index].patchValue({ "name": "subpool" });
            this.clickOnPageTab(this.viewModel.tab);
            this.refreshSubpool.emit(true);
            this.addNewPool.emit(false);
            this.toasterService.openToast('Success', response.message);
          }
        }
      });
  }
  onPageEditTabClickClose(index: number) {
    this.viewModel.showEditSubpoolBlock[index] = false
    this.editSubpoolFormGroup[index].patchValue({ "name": "subpool" })
  }

  addNewSubpool() {
    this.viewModel.submit  = true;
    this.addSubpoolFormGroup.patchValue({ "fleet": this.viewModel.fleet })
    if(this.addSubpoolFormGroup.invalid){
      return;
    }
    this._subpoolService.createSubpool(this.addSubpoolFormGroup.value)
      .subscribe({
        next: (res: any) => {
          const response = res.data.createSubpool;
          if (response.success) {
            this.viewModel.showAddNewSubpoolBlock = false;
            this.refreshSubpool.emit(true);
            this.viewModel.tab = this.addSubpoolFormGroup.value.name;
            this.onPageTabClick.emit(this.addSubpoolFormGroup.value.name);
            this.toasterService.openToast('Success', response.message);
            this.addSubpoolFormGroup.patchValue({ "name": "","fleet": "" });
          }
        }
      });
  }

  deleteSubPool() {
    this._subpoolService.deleteSubpool(this.viewModel.deleteSubPoolName)
      .subscribe({
        next: (res: any) => {
          const response = res.data.deleteSubpool;
          if (response.success) {
            this.viewModel.deleteSubPoolName = "";
            this.viewModel.iDeleteSubpoolForm = false;
            this.refreshSubpool.emit(true);
            this.viewModel.tab = "all";
            this.onPageTabClick.emit("all");
            this.addNewPool.emit(false);
            this.toasterService.openToast('Success', response.message);
          }
        }
      });
  }

  moveShipToSubpool() {
    let shipNumbers = this.viewModel.filteredVesselBySubpool.map((x) => x.vslNumber);
    this._subpoolService.moveShipsOfSubpool(shipNumbers, this.viewModel.moveSubpoolName)
      .subscribe({
        next: (res: any) => {
          const response = res.data.updateSubPoolOfVessels;
          if (response.success) {
            this.deleteSubPool();
            this.toasterService.openToast('Success', 'All ships from Sub '+ this.viewModel.deleteSubPoolName +'  have been moved to Sub '+ this.viewModel.moveSubpoolName +' successfully');
            this.viewModel.moveSubpoolName = "";
            this.viewModel.iDeleteSubpoolMoveForm = false;
            this.viewModel.activeSubPoolsCount = 0;
            this.viewModel.inactiveSubPoolsCount = 0;
          }
        }
      });
  }

  over(e: any, subpool) {
    this.viewModel.showSubpoolAction[subpool] = true;
    this.viewModel.showAddNewSubpoolBlock = false;
    this.subPools.forEach((value: any, index: number) => {
      this.viewModel.showEditSubpoolBlock[index] = false;
      if(subpool != index){
        this.viewModel.showSubpoolAction[index] = false;
      }
    });
    let bodyOffsets = this._el.nativeElement.getBoundingClientRect();
    let dropdownPosition = document.querySelector(`.position-clx-${subpool}`);
    this.viewModel.tempX = (e.pageX - bodyOffsets.left) - 120;
    this.viewModel.tempY = (dropdownPosition?.getBoundingClientRect()?.top || 0) + 20;
  }
  showEdit(e:any){
    let bodyOffsets = this._el.nativeElement.getBoundingClientRect();
    let dropdownPosition = document.querySelector(`.position-clx-add-subpool`);
    this.viewModel.showEditSubpoolX = e?.pageX - bodyOffsets.left - 100;
    this.viewModel.showEditSubpoolY = (dropdownPosition?.getBoundingClientRect()?.top || 0) + 32;
  }
  addSubpoolClick(e: any) {
    let bodyOffsets = this._el.nativeElement.getBoundingClientRect();
    let subpoolSection:any = document.getElementById('subpoolSection');
    let subpoolSectionWidth =  subpoolSection?.clientWidth - 270;
    let dropdownPosition = document.querySelector(`.position-clx-add-subpool`);
    this.viewModel.addNewSubpoolX = e?.pageX - bodyOffsets.left - 100;
    this.viewModel.addNewSubpoolX =  (this.viewModel.addNewSubpoolX > subpoolSectionWidth) ? subpoolSectionWidth : this.viewModel.addNewSubpoolX; 
    this.viewModel.aadNewSubpoolY = (dropdownPosition?.getBoundingClientRect()?.top || 0) + 32;
    
  }

  moreInformation(subpool: any, index: number){
    this.viewModel.subPoolDetail = subpool;
    this.viewModel.iManageSubpool = true;
    this.viewModel.editSubPoolValue = subpool.name;
    this.createSubPoolManageForm();
    this.createSubPoolManageForm();
    this.getSubPoolDurationData();
  }

  getSubpoolsMonthlyData() {
    let formData = { "subpoolName": this.viewModel.editSubPoolValue, "year": this.viewModel.subpoolDurationValue.toString() };
    this._subpoolService.getSubpoolsMonthlyList(formData)
      .subscribe({
        next: (res) => {
          if(res.data.getSubpoolsMonthlyList.success){
            this.viewModel.subpoolsMonthlyList = res.data.getSubpoolsMonthlyList.data;
          }
        }
      });
  }

  getSubPoolDurationData() {
    let formData = { "subpool": this.viewModel.editSubPoolValue};
    this._subpoolService.getSubpoolsYearsList(formData)
      .subscribe({
        next: (res) => {
          if(res.data.getSubpoolsYearsList.success){
            this.viewModel.subPoolsDurations = res.data.getSubpoolsYearsList.data;
            this.viewModel.selectedAttributes =  this.viewModel.subPoolsDurations[0];
            this.viewModel.subpoolDurationValue = this.viewModel.subPoolsDurations[0].value;
	          this.getSubpoolsMonthlyData();
          }
        }
      });
  }

  poolmonth(month){
    return this.viewModel.monthNameArray[month - 1];
  }

  lastMonthDate(type){
    let monthYear = this.getMonthYear();
    let value:any;
    if(type == 'month'){
      value =  this.viewModel.monthNameArray[monthYear.month]
    }
    else if(type == 'year'){
      value = monthYear.year;
    }
    return value
  }

  submitManageSubPool(){
    this.viewModel.manageSubpoolSubmit = true;
    if (this.subPoolManageForm.invalid) {
      return;
    }
    let formData = {
        month: this.subPoolManageForm.value.month,
        year: this.subPoolManageForm.value.year,
        subpoolName: this.subPoolManageForm.value.subpoolName,
        subpoolCode: this.viewModel.subPoolDetail.subpoolCode,
        fleet:this.viewModel.fleet,
        accountingVoyage: parseFloat(this.subPoolManageForm.value.accountingVoyage),
        scrubberSavings: parseFloat(this.subPoolManageForm.value.scrubberSavings),
    };
    this._subpoolService.createSubpoolsMonthlyData(formData)
      .subscribe({
        next: (res: any) => {
          if(res.data.createSubpoolScrubberVoyageMonthly.success){
            this.viewModel.manageSubpoolSubmit = false;
            this.viewModel.iManageSubpoolAdd = false;
            this.getSubpoolsMonthlyData();
            this.toasterService.openToast('Success', res.data.createSubpoolScrubberVoyageMonthly.message);
          }
          else{
            this.viewModel.manageSubpoolSubmit = false;
            this.viewModel.iManageSubpoolAdd = false;
            this.toasterService.openToast("Error",res.data.createSubpoolScrubberVoyageMonthly.message);
          }
          
        }
      });
  }


  getMonthYear(){
    const today = new Date();
    const month = (today.getMonth() == 0) ? 11 : today.getMonth() - 1;
    const year = (today.getMonth() == 0) ? today.getFullYear() - 1 : today.getFullYear();
    return {month:month,year:year};
  }

  disabledManageSubPool(){
    let monthYear = this.getMonthYear();
    if(((this.viewModel.subpoolsMonthlyList && this.viewModel.subpoolsMonthlyList.length > 0) && (monthYear.month == (this.viewModel.subpoolsMonthlyList[this.viewModel.subpoolsMonthlyList.length - 1].month - 1))) || (monthYear.year.toString() != this.viewModel.subpoolDurationValue))
    {
      return true;
    }
    return false;
  }

  changeDurations(event) {
    this.viewModel.subpoolDurationValue = event.value;
    this.getSubpoolsMonthlyData();
  }
  closeManageSubpool(){
    document.body.style.overflow = "auto";
    this.viewModel.iManageSubpool = false;
    this.viewModel.manageSubpoolSubmit = false;
    this.viewModel.iManageSubpoolAdd = false
  }
  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    
    this.subPools.forEach((value: any, index: number) => {
      this.viewModel.showEditSubpoolBlock[index] = false;
      this.viewModel.showSubpoolAction[index] = false;
    })
    event.stopPropagation()  
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
